import React, { useState } from 'react';
import { Section, Card } from './Shared';
import { ChevronDown } from 'lucide-react';
export const TrustAndFAQ = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para mi especialidad dentro de la estética?',
    a: 'Sí. Está diseñado para cualquier profesional del rubro: manicuristas, lashistas, brow artists, cosmetólogas, esteticistas, peluqueras y especialistas en skincare. El sistema de ventas, contenido y fidelización funciona igual para todas las especialidades.'
  }, {
    q: '¿Es un curso grabado?',
    a: 'No. No tenés que sentarte a ver clases ni completar módulos. Es un sistema en PDF: abrís lo que necesitás y lo aplicás de inmediato. Sin esperar. Sin depender de una plataforma.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. Después del pago recibís el acceso por email en menos de 5 minutos. Todo en PDF, listo para leer desde el celular, la tablet o la computadora.'
  }, {
    q: '¿Qué pasa si no sé nada de marketing o redes?',
    a: 'Está pensado exactamente para vos. No necesitás saber nada previo. Todo está explicado en lenguaje simple, con ejemplos reales del rubro estética y recursos listos para copiar y usar hoy.'
  }, {
    q: '¿Por qué es mejor que buscar cosas gratis en Google?',
    a: 'Porque lo que encontrás gratis está disperso, es genérico y no está pensado para el rubro estética en Argentina. El Megakit es un sistema completo, coherente, específico y listo para aplicar. Sin perder horas buscando. Sin armar todo sola desde cero.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Cuál de las dos opciones me conviene?',
    a: 'Si querés más clientas y un sistema de ventas, el Megakit principal es perfecto. Si además querés manejar clientas difíciles, proteger tu tiempo, evitar cancelaciones y construir tu marca, el Megakit + Dueña Pro es la opción completa. Por $8.000 más tenés 4 tomos extra que cambian la forma en que gestionás todo.'
  }, {
    q: '¿Lo puedo pagar en cuotas?',
    a: 'Sí. Mercado Pago ofrece opciones de cuotas según tu tarjeta. Elegís la que mejor te quede al momento del pago.'
  }];
  return <>
      {/* Testimonials Grid */}
      <Section bg="base" data-id="element-469">
        <div className="text-center mb-12" data-id="element-470">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark" data-id="element-471">
            ❤️ Ellas ya tienen el sistema
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-472">
          <Card className="bg-white" data-id="element-473">
            <div className="mb-4 text-brand" data-id="element-474">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-475">
              "Cerré 4 turnos la primera semana con los scripts de WhatsApp.
              Antes esas consultas se me iban todas sin respuesta."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-476">
              — Valeria R. · 📍 Buenos Aires · Manicurista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-477">
            <div className="mb-4 text-brand" data-id="element-478">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-479">
              "Por fin tengo un sistema. Sé qué publicar, cómo responder y cómo
              cobrar. Eso no lo tenía antes de ninguna forma."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-480">
              — Luciana C. · 📍 Córdoba · Lashista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-481">
            <div className="mb-4 text-brand" data-id="element-482">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-483">
              "Subí los precios. No perdí ninguna clienta. Las que se fueron
              eran las que nunca valoraban mi trabajo igual."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-484">
              — Marcela S. · 📍 Rosario · Esteticista
            </p>
          </Card>
          <Card className="bg-white" data-id="element-485">
            <div className="mb-4 text-brand" data-id="element-486">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-487">
              "Publiqué una promo del bono un domingo a la noche. El lunes tenía
              3 turnos confirmados. Así de simple."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-488">
              — Paula G. · 📍 Mendoza · Cosmetóloga
            </p>
          </Card>
          <Card className="bg-white" data-id="element-489">
            <div className="mb-4 text-brand" data-id="element-490">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-491">
              "Recuperé 7 clientas que daba por perdidas con la Máquina de
              Re-Agendamiento. No lo podía creer."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-492">
              — Antonella R. · 📍 Tucumán · Brow Artist
            </p>
          </Card>
          <Card className="bg-white" data-id="element-493">
            <div className="mb-4 text-brand" data-id="element-494">⭐⭐⭐⭐⭐</div>
            <p className="font-montserrat text-gray-700 italic mb-6" data-id="element-495">
              "El Protocolo de Cancelaciones me ahorra peleas y dinero todos los
              meses. Antes perdía turnos sin decir nada."
            </p>
            <p className="font-montserrat text-sm font-bold text-dark" data-id="element-496">
              — Sofía B. · 📍 La Plata · Peluquera
            </p>
          </Card>
        </div>
      </Section>

      {/* Guarantee Section */}
      <Section bg="base" className="border-t border-gray-200" data-id="element-497">
        <div className="max-w-3xl mx-auto text-center" data-id="element-498">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-brand/10 text-brand rounded-full mb-6" data-id="element-499">
            <span className="text-4xl" data-id="element-500">🛡️</span>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark mb-4" data-id="element-501">
            GARANTÍA 7 DÍAS
          </h2>
          <p className="font-montserrat text-xl text-brand font-bold mb-8" data-id="element-502">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <div className="font-montserrat text-lg text-gray-700 space-y-4 mb-8" data-id="element-503">
            <p data-id="element-504">
              Abrís el Megakit. Lo usás en tu negocio. Si en 7 días sentís que
              no es lo que esperabas:
            </p>
            <p className="font-bold text-2xl text-dark" data-id="element-505">Devolución del 100%.</p>
            <p data-id="element-506">Sin explicaciones. Sin burocracia. Solo escribinos y listo.</p>
            <p data-id="element-507">El riesgo es cero. La decisión es tuya.</p>
          </div>

          <div className="bg-mid p-6 rounded-xl border border-gray-200" data-id="element-508">
            <p className="font-montserrat text-sm text-gray-600" data-id="element-509">
              <strong data-id="element-510">Tasa de devoluciones: menos del 1%.</strong> Las que lo
              abren, lo usan. Las que lo usan, no vuelven atrás.
            </p>
          </div>
        </div>
      </Section>

      {/* FAQ Section */}
      <Section bg="mid" data-id="element-511">
        <div className="max-w-3xl mx-auto" data-id="element-512">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dark text-center mb-12" data-id="element-513">
            ❓ Lo que más preguntan
          </h2>

          <div className="space-y-4" data-id="element-514">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-515">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between focus:outline-none" onClick={() => setOpenFaq(openFaq === index ? null : index)} data-id="element-516">
                  <span className="font-montserrat font-bold text-dark pr-4" data-id="element-517">
                    ▸ {faq.q}
                  </span>
                  <ChevronDown className={`text-brand transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} size={20} data-id="element-518" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-519">
                  <p className="font-montserrat text-gray-600 text-sm md:text-base leading-relaxed" data-id="element-520">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
};